/**
 * «Kom i gang»-sjekkliste (UX-prinsipp #2 Goal Gradient, grep B — se
 * docs/plan-ux-principles-retention.md). Klassisk onboarding-gradient: vis et lite
 * antall konkrete steg med hvor mange som er gjort, så nye brukere akselererer mot
 * «ferdig oppsatt». Broen fra ny bruker til vane.
 *
 * Ren og tar ferdig-utregnede boolske signaler, så den er fullt testbar og uavhengig
 * av hvordan de hentes (bruker-doc, besøk, egne plasser).
 *
 * Rekkefølgen er bevisst: de billigste/tidligste stegene først, så gradienten føles
 * oppnåelig. `nextKey` peker på første ugjorte steg (til «neste steg»-uthevingen).
 */

export type SetupStepKey = 'vehicle' | 'avatar' | 'checkin' | 'contribution' | 'notifications';

export interface SetupChecklistInput {
  hasVehicle: boolean;
  hasAvatar: boolean;
  hasCheckin: boolean;
  hasContribution: boolean;
  notificationsEnabled: boolean;
}

export interface SetupStep {
  key: SetupStepKey;
  done: boolean;
}

export interface SetupChecklist {
  steps: SetupStep[];
  doneCount: number;
  total: number;
  allDone: boolean;
  /** Første ugjorte steg, eller null når alt er gjort. */
  nextKey: SetupStepKey | null;
}

const STEP_ORDER: SetupStepKey[] = ['vehicle', 'avatar', 'checkin', 'contribution', 'notifications'];

export function computeSetupChecklist(input: SetupChecklistInput): SetupChecklist {
  const doneByKey: Record<SetupStepKey, boolean> = {
    vehicle: input.hasVehicle,
    avatar: input.hasAvatar,
    checkin: input.hasCheckin,
    contribution: input.hasContribution,
    notifications: input.notificationsEnabled,
  };

  const steps: SetupStep[] = STEP_ORDER.map(key => ({ key, done: doneByKey[key] }));
  const doneCount = steps.filter(s => s.done).length;
  const total = steps.length;
  const nextStep = steps.find(s => !s.done);

  return {
    steps,
    doneCount,
    total,
    allDone: doneCount === total,
    nextKey: nextStep ? nextStep.key : null,
  };
}
